import { registerPlugin } from '@capacitor/core';
export interface CalendarPlugin {
    createCalendarEvent(options: { value: object }): Promise<{ value: string }>;
}
const Calendar= registerPlugin<CalendarPlugin>('Calendar');
export default Calendar;